import React from "react";
import './category.scss';
export default function CategoryContainer(props) {
    return (
        <div className="categories-container">
            {props.children}
        </div>
    )
}